module.exports = __webpack_public_path__ + "img/thumbnail_SableAntelope_m_normal.981b9f92.png";